import React from "react";
import { Form, Input, SelectPicker, Schema } from "rsuite";
import { connect } from "react-redux";
import styled from "styled-components";

import { SP_KEY__INCORPORATED } from "const";
import FormHOC from "hoc/FilltersForm";
import ServicePlans from "components/Filters/ServicePlans";
import CustomField from "components/Form/CustomField";

// const { StringType } = Schema.Types;

const filtersModel = Schema.Model({});


const filters = ({
    filter,
    onChange,
    isSupplier,
    countryList,
    worldzone_list,
    subdestination_list,
    destination_list,
    filteredServicePlanList,
    defaultSPKey,
    pickedPrice,

    pickPrice,
    supplierPriceList
}) => {
    const compareDefaultRateData = [
        {
            label: "Show only lower than default rate",
            value: 1
        },
        {
            label: "Show only higher than default rate",
            value: 2
        }
    ];

    const renderMenuItem = (label, { global, name }) => {
        return (
            <StyledMenuItem global={global} >{name}</StyledMenuItem>
        );
    };

    return (
        <>
            <StyledForm layout="inline"
                formValue={filter}
                onChange={onChange}
                model={filtersModel}
            >

                {isSupplier ? <SelectPicker
                    data={supplierPriceList}
                    cleanable={false}
                    searchable={false}
                    renderMenuItem={renderMenuItem}
                    placeholder={"Select price"}
                    valueKey="id"
                    labelKey="name"
                    value={pickedPrice?.id}
                    onChange={(id) => {
                        const priceValue = supplierPriceList.find(price => price?.id === id);

                        pickPrice(priceValue);
                    }}
                    style={{
                        width: 230
                    }}
                />
                    : <ServicePlans
                        classPrefix="allocated"
                        extraList={filteredServicePlanList}
                        excluded={[SP_KEY__INCORPORATED]}
                    />}
                {!isSupplier ? <CustomField
                    accepter={SelectPicker}
                    labelKey="name"
                    valueKey="wz_key"
                    data={worldzone_list}
                    placeholder="Worldzone"
                    name="wz_key"
                    classPrefix="allocated"
                    menuStyle={{ width: 280 }}
                /> : <></>}
                {isSupplier ? <CustomField
                    accepter={SelectPicker}
                    data={countryList}
                    labelKey="name"
                    valueKey="name"
                    placeholder="Country"
                    name="country"
                    style={{ width: 200 }}
                    menuStyle={{ width: 280 }}
                />
                    : <CustomField
                        accepter={SelectPicker}
                        data={destination_list}
                        labelKey="name"
                        valueKey="de_key"
                        placeholder="Destination"
                        name="de_key"
                        classPrefix="allocated"
                        menuStyle={{ width: 280 }}
                    />}
                {isSupplier ? <CustomField
                    accepter={Input}
                    name="operator"
                    placeholder="Operator"
                    style={{ width: 200 }}
                    menuStyle={{ width: 280 }}
                />
                    : <CustomField
                        accepter={SelectPicker}
                        data={subdestination_list}
                        labelKey="name"
                        valueKey="sde_key"
                        placeholder="Subdestination"
                        name="sde_key"
                        classPrefix="allocated"
                        menuStyle={{ width: 320 }}
                    />}
                {!isSupplier ? <CustomField
                    labelKey="label"
                    valueKey="value"
                    cleanable={true}
                    searchable={false}
                    placeholder="Default rate options"
                    accepter={SelectPicker}
                    name="default_rate"
                    data={compareDefaultRateData}
                /> : <></>}
                {isSupplier ? <CustomField
                    accepter={Input}
                    name="mcc"
                    placeholder="MCC"
                    style={{ width: 80 }}
                /> : <></>}
                {isSupplier ? <CustomField
                    accepter={Input}
                    name="mnc"
                    placeholder="MNC"
                    style={{ width: 80 }}
                /> : <></>}
            </StyledForm>
        </>
    );
};

const mapState = ({ references }) => ({
    defaultSPKey: references.defaultSPKey
});

export default connect(mapState, null)(FormHOC(filters, filtersModel, 800));

const StyledForm = styled(Form)`
    && {
        .rs-form-group {
            margin-bottom: 0px;
        }
        .rs-picker-select {
            margin-bottom: 0px;
        }
    }
`;

const StyledMenuItem = styled.div`
    && {
        font-weight: ${props => !props.global ? "bold" : "normal"};
    }
`;